import LinkIcon from '@mui/icons-material/Link';
import { InputAdornment, MenuItem } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import type { Account } from 'app-components/flux/accounts';
import { accountsSelectors } from 'app-components/flux/accounts';
import type { Map as ImMap } from 'immutable';
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  minWidth: {
    minWidth: 160,
  },
}));

const AccountLink = (props: TextFieldProps & { options?: ImMap<string, Account> }) => {
  const { value, onChange, options, ...other } = props;
  const { classes } = useStyles();
  const accountsById = useSelector(accountsSelectors.getAccountsById);
  const accountOptions = options?.valueSeq() || accountsById;
  return (
    <TextField
      id='link-dropdown'
      select
      label='Link to'
      variant='filled'
      value={value || '0'}
      onChange={onChange}
      fullWidth
      className={classes.minWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <LinkIcon />
          </InputAdornment>
        ),
      }}
      {...other}
    >
      <MenuItem key={'0'} value={'0'}>
        Add as New (no link)
      </MenuItem>
      {accountOptions.map((value) => (
        <MenuItem key={value.id ?? undefined} value={value.id ?? undefined}>
          {value.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default AccountLink;
